import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Profile } from 'selenium-webdriver/firefox';
import { ProfileService } from '../../services/profile.service';
import { FormsService } from '../../services/forms.service';
import { EventService } from '../../services/event.service';
import { LoadingIndicatorService } from '../../services/loading-indicator.service';
import { success, warning, error as exception } from 'toastr';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { CaptchaComponent } from '../../components/captcha/captcha.component';

@Component({
  selector: 'app-check-user',
  templateUrl: './check-user.component.html',
  styleUrls: ['./check-user.component.less']
})

/**
 * Landing page.
 * User submits email adres. When email address hasn't been used to register for this event the user continues to the registration page.
 * When user already has registered, explain to user.
 * Check if registration is open and not all slots have been filled.
 */
export class CheckUserComponent implements OnInit {
  public state: 'event-is-closed' | 'event-is-full' | 'can-register' | 'can-register-reserve';
  public doneLoading = false;
  private eventKey = '';
  public emailAddress = '';
  public eventName: string;
  public eventDescription: string;
  public eventClosedMessage: string;
  public eventFullMessage: string;
  public userAlreadyRegistered = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private eventService: EventService,
    private loader: LoadingIndicatorService) {
    this.route.params.subscribe((p) => {
      this.eventKey = p['eventKey'];
    });
  }

  @ViewChild(CaptchaComponent) recaptcha: CaptchaComponent;

  ngOnInit() {
    this.loader.StartWork();
    this.eventService.get(this.eventKey)
      .then((result) => {
        if (new Date(result.registrationStartDate) > new Date(Date.now()) || new Date(result.registrationEndDate) < new Date(Date.now())) {
          this.eventClosedMessage = result.textRegistrationClosed;
          this.state = 'event-is-closed';
        } else {
          const registrationCount = result.registrationCount || 0;
          // check of er meer registraties gedaan zijn dan maximaal toegestaan
          if (registrationCount >= result.maximumRegistrations && result.isAnonymous === false) {

            // check of er op de reserve lijst (indien gevuld) nog ruimte is
            if (result.maximumOnWaitList > 0) {
              if (registrationCount < (result.maximumRegistrations + result.maximumOnWaitList || 0)) {
                // er is ruimte
                this.eventFullMessage = result.textRegistrationFull;
                this.state = 'can-register-reserve';
              } else {
                // er is geen ruimte
                this.eventFullMessage = result.textWaitlistFull;
                this.state = 'event-is-full';
              }
            } else {
              this.eventFullMessage = result.textRegistrationFull;
              this.state = 'event-is-full';
            }

          } else {
            this.state = 'can-register';
          }
        }

        this.eventName = result.name;
        this.eventDescription = result.description;
        this.doneLoading = true;
        this.loader.EndWork();
      })
      .catch((reason) => {
        this.router.navigate(['/error-page/event-not-found']);
        this.loader.EndWork();
      });
  }

  afterChallengeSuccess(form: UserCheckForm, token: string): void {
    console.log('captcha challenge completed');
    this.SubmitForm(form, token);
  }

  public OnSubmit(form: UserCheckForm): void {
    if (this.recaptcha) {
      this.recaptcha.reset();
      this.recaptcha.challenge();
    }
  }

  private SubmitForm(form: UserCheckForm, token: string): void {
    if (!form.valid) {
      return;
    }

    this.loader.StartWork();
    this.profileService.UserExists(form.value.emailAddress, this.eventKey, token)
      .subscribe((userExists) => {
        const qParams = { queryParams: { email: form.value.emailAddress } };
        if (userExists) {
          this.userAlreadyRegistered = true;
        } else {
          this.router.navigate([`/${this.eventKey}/register`], qParams);
        }
      },
        (error) => {
          // todo
          exception('An error has occured');
          this.loader.EndWork();
        },
        () => {
          this.loader.EndWork();
        });
  }

  public onLeaveEmailAddress(): void {
    this.userAlreadyRegistered = false;
  }
}

interface UserCheckForm extends NgForm {
  value: {
    emailAddress: string;
  };
}
